const now = () => (typeof performance !== "undefined" ? performance.now() : Date.now());

function scrubData(data = {}) {
  return Object.entries(data).reduce((next, [key, value]) => {
    if (/password|token|secret|authorization|apikey|api_key|access_token|refresh_token|phone|email/i.test(key)) {
      next[key] = "[Filtered]";
      return next;
    }

    next[key] = value;
    return next;
  }, {});
}

function recordTiming(entry) {
  if (typeof window === "undefined") return;

  window.__STROBE_PERF__ = Array.isArray(window.__STROBE_PERF__)
    ? window.__STROBE_PERF__
    : [];
  window.__STROBE_PERF__.push(entry);
}

export async function traceAsync(label, callback, data = {}) {
  const startedAt = now();

  try {
    return await callback();
  } finally {
    const durationMs = Math.round(now() - startedAt);
    const safeData = {
      ...scrubData(data),
      durationMs,
      path: typeof window !== "undefined" ? window.location.pathname : "",
    };

    const entry = { label, ...safeData };
    recordTiming(entry);
    console.info(`[perf] ${label}`, safeData);
  }
}
